/** The date of the privacy policy currently shown to recruiters. Update it with each new policy. */
export const PRIVACY_POLICY_VERSION = '2026-10-09';

/** The date of the current consent wording. Update it whenever the consent text changes. */
export const CONSENT_TEXT_VERSION = '2026-10-09';
